<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    @submit="onSaveMenu('submit')"
    @closed="$emit('closed')"
  >
    <slot
      :saveable="saveable"
      :editable="editable"
      :deletable="deletable"
      :view-only="viewOnly"
      :on-save-continue="onSaveContinue"
      :form="form"
    />

    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot
        v-bind="props"
        :name="key"
        :saveable="saveable"
        :editable="editable"
        :deletable="deletable"
        :view-only="viewOnly"
        :form="form"
        :on-save-continue="onSaveContinue"
      />
    </template>

    <template #footer>
      <slot name="footer" :form="form">
        <BFormButtons
          :saveable="saveable"
          :editable="editable"
          :deletable="deletable"
          :view-only="viewOnly"
          :loading="isLoading"
          :save-menu-list="saveMenuList"
          @delete="onDelete"
          @edit="editableInner = !editableInner"
          @save-menu="onSaveMenu($event.name)"
        >
          <template #right>
            <slot name="footer-right" :close="close" :form="form">
              <v-btn text @click="close()" v-text="'Отменить'" />
            </slot>
          </template>
        </BFormButtons>
      </slot>
    </template>
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BFormButtons, { SAVE_MENUS } from '@/components/common/BFormButtons.vue'

export default {
  name: 'BModalForm',
  components: {
    BModalConfirm,
    BFormButtons,
  },
  inheritAttrs: false,
  props: {
    actionSave: Function,
    actionDelete: Function,
    readonly: Boolean,
    viewOnly: Boolean,
    data: Object,
    transformData: {
      type: Function,
      default: (_) => _,
    },
    createDefaultData: {
      type: Function,
      default: () => ({}),
    },
    saveMenuList: {
      type: Array,
      default: () => [
        SAVE_MENUS.SAVE,
        SAVE_MENUS.SAVE_CONTINUE,
        SAVE_MENUS.SAVE_MORE,
      ],
    },
  },
  data: (vm) => ({
    isLoading: false,
    dataInner: vm.data,
    editableInner: vm.readonly,
    form: vm.createDefaultData(vm),
  }),
  computed: {
    saveable() {
      const actions = this.dataInner?.actions
      if (actions && !actions.includes('edit')) return false
      if (this.viewOnly) return false

      return !this.editable
    },
    editable() {
      const actions = this.dataInner?.actions
      if (actions && !actions.includes('edit')) return false
      if (this.viewOnly) return false

      return this.editableInner
    },
    deletable() {
      const actions = this.dataInner?.actions
      if (actions && !actions.includes('delete')) return false
      if (this.viewOnly) return false

      return !!this.form?.id
    },
  },
  watch: {
    dataInner: {
      immediate: true,
      handler(value) {
        const data = value || this.createDefaultData(this)
        this.form = { ...data }
      },
    },
  },
  methods: {
    open() {
      const promise = this.$refs.modal.open()
      return promise.then(this.closeHanlder)
    },
    close() {
      return this.$refs.modal.close()
    },
    async onActionSave() {
      const form = this.transformData(this.form)

      try {
        this.isLoading = true
        const data = await this.actionSave(form)
        return data
      } catch (e) {
        const message = 'Ошибка сохранения'
        const { $errors, $fields } = this
        const options = { $errors, $fields, message }
        this.$notice.errorsResponseForm(e, options)
        return Promise.reject(e)
      } finally {
        this.isLoading = false
      }
    },
    async onSaveMenu(name) {
      const result = await this.$refs.modal.$validator.validate()
      if (!result) return

      switch (name) {
        case 'submit':
        case SAVE_MENUS.SAVE.name:
          await this.onActionSave()
          this.close(true)
          break

        case SAVE_MENUS.SAVE_CONTINUE.name: {
          const data = await this.onActionSave()
          this.dataInner = data
          break
        }

        case SAVE_MENUS.SAVE_MORE.name:
          await this.onActionSave()
          this.dataInner = this.createDefaultData(this)
          break

        default:
          // eslint-disable-next-line no-console
          console.warn(
            `[App warn]: action "${name}" do not support in ${this.$options.name}`,
          )
      }
    },
    onSaveContinue() {
      const { name } = SAVE_MENUS.SAVE_CONTINUE
      this.onSaveMenu(name)
    },
    async onDelete() {
      await this.actionDelete(this.dataInner)
      this.close(true)
    },
    closeHanlder(flag) {
      return flag ? this.form : null
    },
  },
}
</script>
